import { useTranslation } from 'next-i18next/pages';

import { validateEmail } from '@/utils/validationUtils';
import { TRANSLATION_NAMESPACE } from '@/i18n/config';
import { useUserData } from '@/hooks/useUserData';

import { TextInput } from '../../TextInput/TextInput';

const emailValidation = (value: string): boolean => {
  // If the value is empty, return true to let the native validation handle it with valueMissing
  if (!value.trim()) return true;
  return validateEmail(value);
};

export const EmailInput = () => {
  const { userData, isSignedInAndUserDataNotLoaded } = useUserData();
  const { t } = useTranslation(TRANSLATION_NAMESPACE.property_expose);

  if (isSignedInAndUserDataNotLoaded) return null;

  return (
    <TextInput
      label={t('search.contact.form.label.email')}
      name="email"
      defaultValue={userData?.email}
      type="email"
      autoComplete="email"
      isRequired
      validationMessages={{
        valueMissing: t('search.contact.form.validation.email.required'),
        customError: t('search.contact.form.validation.email.invalid'),
      }}
      customValidation={emailValidation}
      validatesOnChange={false}
    />
  );
};
